import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, CircleMarker, Tooltip } from "react-leaflet";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const COLORS = { intervenant: "#1D9BF0", poseur: "#F59E0B" };

export function NetworkMap() {
  const { data } = useQuery({ queryKey: ["network"], queryFn: async () => (await api.get("/network")).data, staleTime: 300000 });
  const points = data?.points || [];

  return (
    <div data-testid="network-map" className="overflow-hidden rounded-3xl border border-slate-200 shadow-xl">
      <MapContainer center={[46.6, 2.5]} zoom={5} scrollWheelZoom={false} style={{ height: "440px", width: "100%", background: "#E0F2FE" }}>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        {points.map((p, i) => (
          <CircleMarker
            key={i}
            center={[p.lat, p.lon]}
            radius={9}
            pathOptions={{ color: "#fff", weight: 2, fillColor: COLORS[p.role] || "#1D9BF0", fillOpacity: 0.95 }}
          >
            <Tooltip>{p.role === "intervenant" ? "Technicien d'entretien" : "Installateur"} — {p.city}</Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
